var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3.50033C3.5 2.21166 4.54467 1.16699 5.83333 1.16699H22.1667C23.4553 1.16699 24.5 2.21166 24.5 3.50033V24.5003C24.5 25.789 23.4553 26.8337 22.1667 26.8337H5.83333C4.54467 26.8337 3.5 25.789 3.5 24.5003V3.50033ZM13.4167 3.50033H10.5V9.06901L11.1832 8.46168C11.6253 8.06876 12.2914 8.06876 12.7334 8.46168L13.4167 9.06901V3.50033ZM8.16667 3.50033H5.83333V24.5003H22.1667V3.50033H15.75V11.667C15.75 12.1264 15.4804 12.5431 15.0613 12.7313C14.6422 12.9195 14.1516 12.8442 13.8082 12.539L11.9583 10.8946L10.1084 12.539C9.76505 12.8442 9.27451 12.9195 8.8554 12.7313C8.4363 12.5431 8.16667 12.1264 8.16667 11.667V3.50033ZM8.16667 16.3337C8.16667 15.6893 8.689 15.167 9.33333 15.167H15.1667C15.811 15.167 16.3333 15.6893 16.3333 16.3337C16.3333 16.978 15.811 17.5003 15.1667 17.5003H9.33333C8.689 17.5003 8.16667 16.978 8.16667 16.3337ZM8.16667 19.8337C8.16667 19.1893 8.689 18.667 9.33333 18.667H18.6667C19.311 18.667 19.8333 19.1893 19.8333 19.8337C19.8333 20.478 19.311 21.0003 18.6667 21.0003H9.33333C8.689 21.0003 8.16667 20.478 8.16667 19.8337Z",
    fill: "#367BBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsActive);
export default __webpack_public_path__ + "static/media/ticketsActive.066a8398febd27966ce13007ab0f0d14.svg";
export { ForwardRef as ReactComponent };